module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "goods"
  }, [_c('latestnews'), _vm._v(" "), _c('pricelist', {
    attrs: {
      "title": '出售大厅',
      "data": _vm.goodList,
      "page": _vm.goodsPage
    },
    on: {
      "showlogin": _vm.showLogin,
      "changepage": _vm.changeGoodsPage,
      "changepagesize": _vm.changeGoodsPageSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a46f916"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/goods/goods.vue
// module id = 629
// module chunks = 31